/**
 * @generated SignedSource<<fd8642ee1fa9fbbdd122e21aedfb24bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateManualOrderInput = {
  clientMutationId?: string | null;
  discountSelection: ReadonlyArray<string>;
  forAccountId: string;
  invoiceNumber: string;
  productSelection: ReadonlyArray<ProductSelectionInput>;
};
export type ProductSelectionInput = {
  amount: number;
  price: PriceInput;
  productId: string;
};
export type PriceInput = {
  grossPrice?: any | null;
  netPrice?: any | null;
  taxRatePercentage: any;
};
export type upsertManualOrderModal_UpsertManualOrderModalMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateManualOrderInput;
};
export type upsertManualOrderModal_UpsertManualOrderModalMutation$data = {
  readonly Admin: {
    readonly Billing: {
      readonly createManualOrder: {
        readonly manualOrder: {
          readonly node: {
            readonly " $fragmentSpreads": FragmentRefs<"manualOrdersTable_ManualOrderFragment">;
          };
        };
      } | null;
    };
  };
};
export type upsertManualOrderModal_UpsertManualOrderModalMutation = {
  response: upsertManualOrderModal_UpsertManualOrderModalMutation$data;
  variables: upsertManualOrderModal_UpsertManualOrderModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceNumber",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductSelection",
  "kind": "LinkedField",
  "name": "productSelection",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Price",
      "kind": "LinkedField",
      "name": "price",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "grossPrice",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "netPrice",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "taxRatePercentage",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "DiscountCode",
  "kind": "LinkedField",
  "name": "discountSelection",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numUsages",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "upsertManualOrderModal_UpsertManualOrderModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Billing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "CreateManualOrderPayload",
                "kind": "LinkedField",
                "name": "createManualOrder",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ManualOrdersEdge",
                    "kind": "LinkedField",
                    "name": "manualOrder",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ManualOrder",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "manualOrdersTable_ManualOrderFragment",
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "salesPerson",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v6/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/)
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "upsertManualOrderModal_UpsertManualOrderModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Billing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "CreateManualOrderPayload",
                "kind": "LinkedField",
                "name": "createManualOrder",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ManualOrdersEdge",
                    "kind": "LinkedField",
                    "name": "manualOrder",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ManualOrder",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "salesPerson",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "appendEdge",
                    "key": "",
                    "kind": "LinkedHandle",
                    "name": "manualOrder",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f8ceb7728ae6e2803b052f00bf3f6ae7",
    "id": null,
    "metadata": {},
    "name": "upsertManualOrderModal_UpsertManualOrderModalMutation",
    "operationKind": "mutation",
    "text": "mutation upsertManualOrderModal_UpsertManualOrderModalMutation(\n  $input: CreateManualOrderInput!\n) {\n  Admin {\n    Billing {\n      createManualOrder(input: $input) {\n        manualOrder {\n          node {\n            ...manualOrdersTable_ManualOrderFragment\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment manualOrdersTable_ManualOrderFragment on ManualOrder {\n  id\n  invoiceNumber\n  salesPerson {\n    name\n    id\n  }\n  createdAt\n  productSelection {\n    product {\n      id\n      title\n    }\n    price {\n      grossPrice\n      netPrice\n      taxRatePercentage\n    }\n  }\n  discountSelection {\n    id\n    code\n    createdAt\n    numUsages\n  }\n}\n"
  }
};
})();

(node as any).hash = "e037aea2bd52545d811795b15eaaf415";

export default node;
